export const requiredMessage = (fieldName: string) => `${fieldName} is required`
export const invalidEmailMessage = () => `Invalid Email`
